import { addBreadcrumb, captureException } from "@/utils/sentry";
import { Kind } from "graphql";
import { type CombinedError, type Operation, mapExchange } from "urql";

const AUTH_NOT_AUTHENTICATED = "AUTH_NOT_AUTHENTICATED";

const isAuthError = (error: CombinedError): boolean =>
  error.graphQLErrors.some(
    (e) => e.extensions?.code === AUTH_NOT_AUTHENTICATED
  );

const getOperationName = (operation: Operation): string =>
  operation.query.definitions.find(
    (def) => def.kind === Kind.OPERATION_DEFINITION
  )?.name?.value ?? "unknown";

export const reportGraphQLError = (
  error: CombinedError,
  operation: Operation
): void => {
  if (isAuthError(error)) {
    return;
  }

  const operationName = getOperationName(operation);

  if (error.networkError) {
    addBreadcrumb({
      category: "graphql",
      message: `Network error: ${operationName}`,
      level: "warning",
      data: { operationName, error: error.networkError.message },
    });
    return;
  }

  captureException(error, {
    operationName,
    operationKind: operation.kind,
    graphQLErrors: error.graphQLErrors.map((e) => e.message),
  });
};

export const errorReportingExchange = mapExchange({
  onError: reportGraphQLError,
});
